import { z } from 'zod';

import {
  allowVariablePlaceholders,
  thisReferenceSchema,
} from '$lib/config-schemas/raw-variable-placeholder';

import { createGeometrySchema } from './geometry';
import { createOrientationSchema } from './orientation';
import { createTranslationSchema } from './translation';

export const createFrameSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      // When variables are allowed, don't apply defaults as they interfere with variable placeholders.
      // In fragment configs, `parent` may also be a `$this` reference to another
      // named resource in the same fragment
      parent: allowVariables
        ? z.string().or(thisReferenceSchema)
        : z.string().default('world'),
      translation: allowVariablePlaceholders(
        createTranslationSchema(allowVariables),
        allowVariables
      ).optional(),
      orientation: createOrientationSchema(allowVariables).optional(),
      geometry: createGeometrySchema(allowVariables).optional(),
    }),
    allowVariables
  );
};

export const FrameSchema = createFrameSchema();

export type Frame = z.infer<typeof FrameSchema>;

export const DEFAULT_FRAME = {
  parent: 'world',
  translation: {
    x: 0,
    y: 0,
    z: 0,
  },
  orientation: {
    type: 'ov_degrees',
    value: {
      x: 0,
      y: 0,
      z: 1,
      th: 0,
    },
  },
} satisfies Frame;
